import React from "react";
import { Modal } from "react-bootstrap";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import HelpAccordion from "./helpPage/HelpAccordion";
import useHelpModalController from "./helpPage/useHelpModalController";

export default function HelpModal({ show, onHide }) {
  const { draggableRef } = useHelpModalController();

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={false}
      dialogAs={({ children }) => (
        <Draggable nodeRef={draggableRef} handle=".modal-header">
          <div
            ref={draggableRef}
            style={{ position: "absolute", top: "15%", left: "20%" }}
          >
            <Resizable
              defaultSize={{ width: 800, height: 550 }}
              minWidth={500}
              minHeight={350}
              enable={{
                top: false,
                right: true,
                bottom: true,
                left: false,
                topRight: true,
                bottomRight: true,
                bottomLeft: true,
                topLeft: true
              }}
            >
              <div
                className="modal-content"
                style={{
                  height: "100%",
                  display: "flex",
                  marginBottom: "2rem",
                  flexDirection: "column"
                }}
              >
                {children}
              </div>
            </Resizable>
          </div>
        </Draggable>
      )}
    >
      <Modal.Header closeButton style={{ cursor: "move" }}>
        <Modal.Title>Hogyan csináld?</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowY: "auto", marginBottom: "15px" }}>
        <HelpAccordion />
      </Modal.Body>
    </Modal>
  );
}
